import React from 'react';
import { motion } from 'framer-motion';
import { Check, Lock, Zap } from 'lucide-react';
export function Pricing() {
  const features = ['6 Tomos completos', '6 Bonos exclusivos (valor $90.000)', 'Más de 1000 actividades', 'Actualizaciones futuras', 'Acceso inmediato'];
  return <section id="pricing" className="py-24 bg-ink-50 relative overflow-hidden" data-id="element-144">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[700px] bg-brand-50 rounded-full blur-3xl opacity-80 pointer-events-none" data-id="element-145"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-147">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-ink-900 text-white font-bold text-xs uppercase tracking-wider mb-6 shadow-lg" data-id="element-148">
            <Zap className="w-4 h-4 text-brand-500" data-id="element-149" />
            Oferta · Últimos cupos
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-ink-900 tracking-tight leading-tight" data-id="element-150">
            Reservá tu acceso al{' '}
            <span className="text-brand-500" data-id="element-151">Mega Pack</span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[2rem] p-8 md:p-12 shadow-card border border-ink-100 relative max-w-xl mx-auto" data-id="element-152">
          {/* Top tag */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-brand-500 text-white font-black px-6 py-2 rounded-full text-xs uppercase tracking-widest shadow-cta whitespace-nowrap" data-id="element-153">
            Acceso completo
          </div>

          <div className="text-center mb-8 pt-2" data-id="element-154">
            <div className="text-ink-900 font-extrabold text-xl mb-1" data-id="element-155">
              Mega Pack Artística Lista
            </div>
            <p className="text-ink-500 text-sm mb-6" data-id="element-156">
              6 Tomos + 6 Bonos + Garantía 7 días
            </p>

            <div className="mb-2 flex items-center justify-center gap-3" data-id="element-157">
              <span className="text-ink-400 line-through text-2xl font-medium" data-id="element-158">
                $64.990
              </span>
              <span className="bg-brand-50 text-brand-700 font-black text-xs px-2.5 py-1 rounded-md uppercase tracking-wider" data-id="element-159">
                -70%
              </span>
            </div>
            <div className="text-6xl md:text-7xl font-black text-ink-900 mb-2 tracking-tight" data-id="element-160">
              $19.990
            </div>
            <p className="text-sm text-ink-500 font-medium" data-id="element-161">
              Pago único · Sin suscripción
            </p>
          </div>

          <div className="space-y-3 mb-8 bg-ink-50 rounded-2xl p-5" data-id="element-162">
            {features.map((feature, i) => <div key={i} className="flex items-center gap-3" data-id="element-163">
                <div className="w-6 h-6 rounded-full bg-brand-500 text-white flex items-center justify-center shrink-0" data-id="element-164">
                  <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-165" />
                </div>
                <span className="text-ink-900 font-semibold text-base" data-id="element-166">
                  {feature}
                </span>
              </div>)}
          </div>

          <a href="https://www.iterapro.shop/cart/43365633065049:1" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-brand-500 hover:bg-brand-600 text-white font-black py-5 px-6 rounded-2xl transition-all transform hover:-translate-y-0.5 shadow-cta hover:shadow-xl text-lg uppercase tracking-wide" data-id="element-167">
            QUIERO MI MEGA PACK
          </a>

          <p className="text-center text-xs text-ink-500 mt-4 inline-flex items-center justify-center gap-1.5 w-full" data-id="element-168">
            <Lock className="w-3.5 h-3.5" data-id="element-169" />
            Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </p>
        </motion.div>
      </div>
    </section>;
}